import React from "react";
import getClassNameFactory from "../../utilities/classNames";

var Standfirst = function Standfirst(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory(Standfirst.displayName);
  return /*#__PURE__*/React.createElement("p", {
    className: getClassName()
  }, children);
};

Standfirst.displayName = "Standfirst";
export default Standfirst;